import { useEffect } from 'react';
import { useQuery } from '@tanstack/react-query';
import { UserRole } from '@academia-apolo/shared-types';
import { apiClient } from '@/lib/api-client';
import { useMe } from '@/features/auth/hooks/useMe';
import { useTheme } from '@/providers/ThemeProvider';
function normalize(type) {
    if (type === 'policia_local' || type === 'policia_nacional' || type === 'bomberos') {
        return type;
    }
    return 'none';
}
/**
 * Syncs the theme opposition with the authenticated user:
 * - STUDENT → fetches /students/me and sets data-opposition to their opposition_type
 * - DIRECTOR/PROFESSOR → 'none' (brand theme)
 */
export function useOppositionSync() {
    const { data: user } = useMe();
    const { setOpposition } = useTheme();
    const isStudent = user?.role === UserRole.STUDENT;
    const { data: studentMe } = useQuery({
        queryKey: ['students', 'me'],
        queryFn: () => apiClient('/students/me'),
        enabled: isStudent,
        staleTime: 1000 * 60 * 10,
    });
    useEffect(() => {
        if (!user)
            return;
        if (isStudent) {
            setOpposition(normalize(studentMe?.opposition_type));
        }
        else {
            setOpposition('none');
        }
    }, [user, isStudent, studentMe?.opposition_type, setOpposition]);
}
//# sourceMappingURL=useOppositionSync.js.map